<template>
<!-- 海报首页 -->
  <div class="school-card">
      <img class="bg" src="https://themes-cdn.xjy.cn/statics/career/images/other/poster_card_poster/poster-bg1.png" alt="">
      <div @click="toPosterCreated()" :class="['btn',bool?'on':'']">
      <!--  animated pulse infinite -->
        <img  src="https://themes-cdn.xjy.cn/statics/career/images/other/poster_card_poster/poster-btn1.png" alt="">
      </div>
  </div>
</template>

<script>
import { shareCon } from "@/utils/wxconfig";
export default {
    data(){
        return{
            bool:false
        }
    },
    mounted(){
        $(window).scroll(()=>{
            this.bool = $(document).scrollTop() >35?true:false;
        });
    },
    methods:{
        // 跳转海报生成页面
        toPosterCreated(){
            let obj = {
                path:'/poster_card_form'
            };
            if(this.$route.query.from_user_id){
                    obj['from_user_id'] = this.$route.query.from_user_id;
                }
            this.$router.push(obj);
        },
        // 初始化获取数据
        pullData(){
            document.title = '我与新精英的“ 2020 ”';
            shareCon("index", this);
        }
    },
    created(){
        this.pullData();
    }
}
</script>
<style lang="scss">
    body{
        background-color: #ffffff;
    }
</style>
<style  lang="scss" scoped>

.school-card{
    position: relative;
    .bg{
        width: 100%;
    }
    .btn{
        width: 390px;
        height: 100px;
        text-align: center;
        border: none;
        position: fixed;
        bottom: 130px;
        left: 50%;
        transition:  all 1s;
        transform: translateX(-50%);
        img{
            width: 100%;
            height: 100%;
            position: absolute;
            top: 0;
            left: 0;
            animation: scaleDraw 2s  infinite;
        }
    }
    
    .btn.on{
        top: 1103px;
        position: absolute;
    }
}


</style>